module.exports = __webpack_public_path__ + "static/media/plex_new.cb6d6dfc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/plex_new.png
// module id = 244
// module chunks = 0